<template>
  <td
    class="text-end"
    @click="startEdit"
  >
    <span v-if="!isEditing">
      {{ $formatters.formatCurrency(displayValue) }}
      <i class="bi bi-pencil"></i>
    </span>
    <input
      v-else
      ref="inputRef"
      class="form-control-sm text-end"
      v-model="editValue"
      type="text"
      @blur="handleCommit"
      @keydown.enter="handleCommit"
      @keydown.escape="handleDiscard"
      @mousedown.stop
    />
  </td>
</template>

<script setup>
import { ref, computed, nextTick,defineProps,defineEmits } from 'vue';
const props = defineProps({
  modelValue: { type: Number, required: true },
  id: {
    type: String, // Accept as string
    default: '0',
  }
});

const emit = defineEmits(['update:modelValue','change']);

// Editing state
const isEditing = ref(false);
const inputRef = ref(null);
const editValue = ref('');
const originalValue = ref(0);

// Display formatted value
const displayValue = computed(() => 
  props.modelValue
);

// Start editing
const startEdit = () => {
  isEditing.value = true;
  originalValue.value = props.modelValue;
  editValue.value = displayValue.value; // Show formatted string
  
  nextTick(() => {
    inputRef.value?.focus();
    inputRef.value?.select();
  });
};

// Commit changes
const handleCommit = () => {
  if (!isEditing.value) return;
  
  // Parse number from formatted string
const numValue = parseFloat(String(editValue?.value || '').replace(/[^0-9.-]/g, ''));
  if (!isNaN(numValue)) {
    emit('update:modelValue', numValue);
    emit('change', props.id);
  }
  
  isEditing.value = false;
};

// Discard changes
const handleDiscard = () => {
  editValue.value = originalValue.value;
  isEditing.value = false;
};
</script>

<style scoped>
td {
  cursor: pointer;
  min-width: 100px;
}
</style>